import type { Configuration } from '../..';
import HttpMethod from '../../request/HttpMethod';
import Requester from '../../request/Requester';
import { toVoiceChatBalance, type VoiceChatBalance } from './VoiceChatBalanceTransformer';
import { VoiceChatSocket } from './VoiceChatSocket';

/**
 * Factory for voice-chat WebSocket sessions. Browsers cannot send auth headers on a
 * WebSocket handshake, so the session token (renewed via Requester.getValidToken)
 * travels as the second entry of the subprotocol list.
 */
export class VoiceChatRequester {
  private requester: Requester;
  private host: string;

  constructor(configuration: Configuration) {
    this.requester = new Requester(configuration);
    this.host = configuration.host;
  }

  public createSocket = (): VoiceChatSocket => {
    return new VoiceChatSocket({
      host: this.host,
      getToken: async () => (await this.requester.getValidToken()) ?? null,
    });
  };

  /** Saldo mensal de voz do device (quota é por SIM de cada câmera; default 120 min/mês). */
  public getDeviceBalance = async (deviceId: string): Promise<VoiceChatBalance> => {
    const { data } = await this.requester.request({
      endpoint: `/cameras/voice/devices/${deviceId}/balance`,
      method: HttpMethod.GET,
    });
    return toVoiceChatBalance(data);
  };
}

export default VoiceChatRequester;
